// extracted by mini-css-extract-plugin
module.exports = {"root":"AppSettingsDialog_root__2-Ijf"};